import React, { useEffect } from 'react'
import QRImage from '../../../../../../asset/svg/registerAssetQRImage.svg';
import LeftArrow from '../../../../../../asset/svg/leftArrow.svg';
import { useLocation, useNavigate } from 'react-router';
import '../../../../../../scss/pages/Attendance/Component/Asset/Assets/RegisterAssetDownloadQR/registerAssetDownloadQR.scss';
import { Typography } from '@mui/material';
import { ASSET_GROUP_PATH } from '../../../../../../utils/Constants';
import { useDispatch, useSelector } from 'react-redux';


function RegisterAssetDownloadOR() {
    const navigate = useNavigate();
    const { RegisterAssetGetQRCode } = useSelector(mapStateToProps);
    console.log("QR Data", RegisterAssetGetQRCode);
    const handleBack = () => {
        navigate(ASSET_GROUP_PATH)
    }
    const { assetCode, name } = RegisterAssetGetQRCode;
    return (
        <div className='RegisterDownloadQR-Container'>
            <div className='RegisterDownloadQR-Container_header'>
                <div>
                    <img className='RegisterDownloadQR-Container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                    <span className='RegisterDownloadQR-Container_header_content'>Download QR</span>
                </div>
            </div>
            <div className='RegisterDownloadQR-Container_Verify-image-parent'>
                <div>
                    <img className='RegisterDownloadQR-Container_Verify-image' src={QRImage} />
                </div>
            </div>
            <div className='RegisterDownloadQR-Container_QR-description'>
                <div className='RegisterDownloadQR-Container_QR-description_container'>
                    <Typography color="rgba(255, 255, 255, 1)" fontSize='16px' fontWeight={500} style={{ opacity: "0.4" }}>{assetCode}</Typography>
                    <Typography color="rgba(255, 255, 255, 1)" fontSize='16px' fontWeight={500} style={{ opacity: "0.4" }}>{name}</Typography>
                </div>
                <div style={{ marginTop: "12%" }}>
                    <button type='submit' className='RegisterVerifyOtp-Container_section_verifyBox_active-button'>Download</button>
                </div>
            </div>

        </div>
    )
}


const mapStateToProps = (state) => {
    return {
        RegisterAssetGetQRCode: state.attendanceConfig.RegisterAssetGetQRCode,
    }
}

export default RegisterAssetDownloadOR;